module.exports = __webpack_public_path__ + "img/flip2.65679fb4.png";